import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundMessages = defineMessages({
	sectionLabel: {
		id: 'JsmPortalPlayground.sectionLabel',
		defaultMessage: 'Jira Service Management preview',
	},
	serviceTeamTabListLabel: {
		id: 'JsmPortalPlayground.serviceTeamTabListLabel',
		defaultMessage: 'Service team',
	},
	teamItSupport: {
		id: 'JsmPortalPlayground.teamItSupport',
		defaultMessage: 'IT support',
	},
	teamItOperations: {
		id: 'JsmPortalPlayground.teamItOperations',
		defaultMessage: 'IT operations',
	},
	teamEngineering: {
		id: 'JsmPortalPlayground.teamEngineering',
		defaultMessage: 'Engineering',
	},
	teamHr: {
		id: 'JsmPortalPlayground.teamHr',
		defaultMessage: 'HR',
	},
	customCursorLabel: {
		id: 'JsmPortalPlayground.customCursorLabel',
		defaultMessage: 'You',
	},
	seeHowItWorks: {
		id: 'JsmPortalPlayground.seeHowItWorks',
		defaultMessage: 'See how it works',
	},
	navigationPreviewLabel: {
		id: 'JsmPortalPlayground.navigationPreviewLabel',
		defaultMessage: 'Jira Service Management navigation preview for {teamName}',
	},
	productName: {
		id: 'JsmPortalPlayground.productName',
		defaultMessage: 'Jira Service Management',
	},
	back: {
		id: 'JsmPortalPlayground.back',
		defaultMessage: 'Back',
	},
	search: {
		id: 'JsmPortalPlayground.search',
		defaultMessage: 'Search',
	},
	create: {
		id: 'JsmPortalPlayground.create',
		defaultMessage: 'Create',
	},
	askRovo: {
		id: 'JsmPortalPlayground.askRovo',
		defaultMessage: 'Ask Rovo',
	},
	brandName: {
		id: 'JsmPortalPlayground.brandName',
		defaultMessage: 'Jira Service Management',
	},
	helpCenterTitle: {
		id: 'JsmPortalPlayground.helpCenterTitle',
		defaultMessage: 'Help center',
	},
	helpCenterSubtitle: {
		id: 'JsmPortalPlayground.helpCenterSubtitle',
		defaultMessage: 'Find helpful articles, forms and more - or ask Rovo for help',
	},
	askAiPlaceholder: {
		id: 'JsmPortalPlayground.askAiPlaceholder',
		defaultMessage: 'Ask AI for answers, support articles, or to raise a request for you.',
	},
	findHelpHeading: {
		id: 'JsmPortalPlayground.findHelpHeading',
		defaultMessage: 'Find the help you need',
	},
	customizeHelpCenter: {
		id: 'JsmPortalPlayground.customizeHelpCenter',
		defaultMessage: 'Customize the help center',
	},
	incidentTitle: {
		id: 'JsmPortalPlayground.incidentTitle',
		defaultMessage: 'Service outage impacting Payment API',
	},
	addToWorkItem: {
		id: 'JsmPortalPlayground.addToWorkItem',
		defaultMessage: 'Add to work item',
	},
	description: {
		id: 'JsmPortalPlayground.description',
		defaultMessage: 'Description',
	},
	collapseDescription: {
		id: 'JsmPortalPlayground.collapseDescription',
		defaultMessage: 'Collapse description',
	},
	expandDescription: {
		id: 'JsmPortalPlayground.expandDescription',
		defaultMessage: 'Expand description',
	},
	incidentDescriptionStart: {
		id: 'JsmPortalPlayground.incidentDescriptionStart',
		defaultMessage: 'Customers are unable to complete transactions.',
	},
	incidentDescriptionEnd: {
		id: 'JsmPortalPlayground.incidentDescriptionEnd',
		defaultMessage: 'alerts have indicated <service>Payment API</service> disruptions.',
	},
	impactedService: {
		id: 'JsmPortalPlayground.impactedService',
		defaultMessage: 'Impacted service',
	},
	paymentApi: {
		id: 'JsmPortalPlayground.paymentApi',
		defaultMessage: 'Payment API',
	},
	onCall: {
		id: 'JsmPortalPlayground.onCall',
		defaultMessage: 'On call',
	},
	open: {
		id: 'JsmPortalPlayground.open',
		defaultMessage: 'Open',
	},
	investigating: {
		id: 'JsmPortalPlayground.investigating',
		defaultMessage: 'Investigating',
	},
	monitoring: {
		id: 'JsmPortalPlayground.monitoring',
		defaultMessage: 'Monitoring',
	},
	resolved: {
		id: 'JsmPortalPlayground.resolved',
		defaultMessage: 'Resolved',
	},
	runAutomation: {
		id: 'JsmPortalPlayground.runAutomation',
		defaultMessage: 'Run an automation rule',
	},
	details: {
		id: 'JsmPortalPlayground.details',
		defaultMessage: 'Details',
	},
	collapseDetails: {
		id: 'JsmPortalPlayground.collapseDetails',
		defaultMessage: 'Collapse details',
	},
	assignee: {
		id: 'JsmPortalPlayground.assignee',
		defaultMessage: 'Assignee',
	},
	responders: {
		id: 'JsmPortalPlayground.responders',
		defaultMessage: 'Responders',
	},
	requestType: {
		id: 'JsmPortalPlayground.requestType',
		defaultMessage: 'Request Type',
	},
	incident: {
		id: 'JsmPortalPlayground.incident',
		defaultMessage: 'Incident',
	},
	majorIncident: {
		id: 'JsmPortalPlayground.majorIncident',
		defaultMessage: 'Major incident',
	},
	collaborationChannels: {
		id: 'JsmPortalPlayground.collaborationChannels',
		defaultMessage: 'Collaboration channels',
	},
	rovoOpsTitle: {
		id: 'JsmPortalPlayground.rovoOpsTitle',
		defaultMessage: 'Accelerate incident resolution with Rovo Ops',
	},
	rovoOpsDescription: {
		id: 'JsmPortalPlayground.rovoOpsDescription',
		defaultMessage:
			'Leverage Rovo Ops to find similar incidents, identify root causes, and gather incident context.',
	},
	identifyRootCauses: {
		id: 'JsmPortalPlayground.identifyRootCauses',
		defaultMessage: 'Identify root causes',
	},
	findSimilarIncidents: {
		id: 'JsmPortalPlayground.findSimilarIncidents',
		defaultMessage: 'Find similar incidents',
	},
	likelyRootCauses: {
		id: 'JsmPortalPlayground.likelyRootCauses',
		defaultMessage: 'Likely root causes',
	},
	regenerateRootCauses: {
		id: 'JsmPortalPlayground.regenerateRootCauses',
		defaultMessage: 'Regenerate root causes',
	},
	collapseRovoOps: {
		id: 'JsmPortalPlayground.collapseRovoOps',
		defaultMessage: 'Collapse Rovo Ops',
	},
	expandRovoOps: {
		id: 'JsmPortalPlayground.expandRovoOps',
		defaultMessage: 'Expand Rovo Ops',
	},
	sources: {
		id: 'JsmPortalPlayground.sources',
		defaultMessage: 'Sources',
	},
	rovoOps: {
		id: 'JsmPortalPlayground.rovoOps',
		defaultMessage: 'Rovo Ops',
	},
	slack: {
		id: 'JsmPortalPlayground.slack',
		defaultMessage: 'Slack',
	},
	zoom: {
		id: 'JsmPortalPlayground.zoom',
		defaultMessage: 'Zoom',
	},
	paymentTeam: {
		id: 'JsmPortalPlayground.paymentTeam',
		defaultMessage: 'Payment Team',
	},
	alertSmartLinkTitle: {
		id: 'JsmPortalPlayground.alertSmartLinkTitle',
		defaultMessage: 'Payment – High Error Rate',
	},
	alertSmartLinkLabel: {
		id: 'JsmPortalPlayground.alertSmartLinkLabel',
		defaultMessage: 'P1 Payment – High Error Rate, 172 alerts',
		description: 'Accessible name for a P1 alert link. P1 is the alert priority.',
	},
	rootCauseStepDeployments: {
		id: 'JsmPortalPlayground.rootCauseStepDeployments',
		defaultMessage: 'Searching recent <chip>Payment API</chip> deployments',
	},
	rootCauseStepFeatureFlags: {
		id: 'JsmPortalPlayground.rootCauseStepFeatureFlags',
		defaultMessage: 'Scanning feature flags <chip>Payment FF</chip>',
	},
	rootCauseStepPairing: {
		id: 'JsmPortalPlayground.rootCauseStepPairing',
		defaultMessage:
			'Finding likely root causes and pairing with recent <chip>New Payment</chip> release',
	},
	rootCauseStepDone: {
		id: 'JsmPortalPlayground.rootCauseStepDone',
		defaultMessage: 'Done',
	},
	rootCauseStepInProgress: {
		id: 'JsmPortalPlayground.rootCauseStepInProgress',
		defaultMessage: 'In progress',
	},
	rootCauseStepNotStarted: {
		id: 'JsmPortalPlayground.rootCauseStepNotStarted',
		defaultMessage: 'Not started',
	},
	rootCauseDeployment: {
		id: 'JsmPortalPlayground.rootCauseDeployment',
		defaultMessage: 'Deployment',
	},
	rootCauseFeatureFlag: {
		id: 'JsmPortalPlayground.rootCauseFeatureFlag',
		defaultMessage: 'Feature flag',
	},
	rootCauseConfidenceHigh: {
		id: 'JsmPortalPlayground.rootCauseConfidenceHigh',
		defaultMessage: 'High',
	},
	rootCauseConfidenceMedium: {
		id: 'JsmPortalPlayground.rootCauseConfidenceMedium',
		defaultMessage: 'Medium',
	},
	rootCauseConfidenceLow: {
		id: 'JsmPortalPlayground.rootCauseConfidenceLow',
		defaultMessage: 'Low',
	},
	rootCauseDeployedTwoDaysAgo: {
		id: 'JsmPortalPlayground.rootCauseDeployedTwoDaysAgo',
		defaultMessage: 'Deployment to production 2 days ago',
	},
	rootCauseDeployedEightDaysAgo: {
		id: 'JsmPortalPlayground.rootCauseDeployedEightDaysAgo',
		defaultMessage: 'Deployed to production 8 days ago',
	},
	rootCauseCardLabel: {
		id: 'JsmPortalPlayground.rootCauseCardLabel',
		defaultMessage: '{title}, {confidence} confidence, {reference}: {detail}',
		description:
			'Accessible name for a likely root cause card. {reference} is a work item key such as DEP-874.',
	},
	rootCauseInsightLikely: {
		id: 'JsmPortalPlayground.rootCauseInsightLikely',
		defaultMessage:
			'<strong>Likely cause of outage.</strong> There are patterns of recent alerts that have similar root causes of <service>Payment API</service>. This was most likely caused by the recent deployment <deployment>Update payment</deployment> 2 days ago',
	},
	rootCauseInsightPossible: {
		id: 'JsmPortalPlayground.rootCauseInsightPossible',
		defaultMessage:
			'<strong>Possible contributing factor.</strong> The feature flag <featureFlag>Payment FF</featureFlag> was enabled on <service>Payment API</service> 8 days ago and touches a related code path, though its rollout window is less closely aligned with the alert spike than the deployment above.',
	},
	rootCauseInsightUnlikely: {
		id: 'JsmPortalPlayground.rootCauseInsightUnlikely',
		defaultMessage:
			'<strong>Unlikely, but not ruled out.</strong> The deployment <deployment>Payment retries</deployment> shipped 8 days ago and touches this service, but its timing correlates weakly with the alert spike compared to the more recent changes above.',
	},
	skipAnimation: {
		id: 'JsmPortalPlayground.skipAnimation',
		defaultMessage: 'Skip animation',
	},
	customizePanelTitle: {
		id: 'JsmPortalPlayground.customizePanelTitle',
		defaultMessage: 'Customize look and feel',
	},
	helpCenterNameField: {
		id: 'JsmPortalPlayground.helpCenterNameField',
		defaultMessage: 'Help center name',
	},
	logoField: {
		id: 'JsmPortalPlayground.logoField',
		defaultMessage: 'Logo',
	},
	bannerField: {
		id: 'JsmPortalPlayground.bannerField',
		defaultMessage: 'Help center banner',
	},
	textColorField: {
		id: 'JsmPortalPlayground.textColorField',
		defaultMessage: 'Text color',
	},
	primaryColorField: {
		id: 'JsmPortalPlayground.primaryColorField',
		defaultMessage: 'Primary color',
	},
	secondaryColorField: {
		id: 'JsmPortalPlayground.secondaryColorField',
		defaultMessage: 'Secondary color',
	},
	togglePrimaryColor: {
		id: 'JsmPortalPlayground.togglePrimaryColor',
		defaultMessage: 'Change the article banner color',
	},
	toggleSecondaryColor: {
		id: 'JsmPortalPlayground.toggleSecondaryColor',
		defaultMessage: 'Change the article icon color',
	},
	readArticle: {
		id: 'JsmPortalPlayground.readArticle',
		defaultMessage: 'Read the article: {title}',
	},
	lastUpdated: {
		id: 'JsmPortalPlayground.lastUpdated',
		defaultMessage: 'Last updated {date}',
		description: 'When a help center article was last edited. {date} is a formatted date.',
	},
	createdWithRovo: {
		id: 'JsmPortalPlayground.createdWithRovo',
		defaultMessage: 'Created with Rovo',
	},
	cardLaptopTag: {
		id: 'JsmPortalPlayground.cardLaptopTag',
		defaultMessage: 'How-to guides',
	},
	cardLaptopTitle: {
		id: 'JsmPortalPlayground.cardLaptopTitle',
		defaultMessage: 'Set up your new laptop',
	},
	cardLaptopDesc: {
		id: 'JsmPortalPlayground.cardLaptopDesc',
		defaultMessage:
			"Whether you're new to the company or replacing your device, this guide walks you through everything you need to get started.",
	},
	cardVpnTag: {
		id: 'JsmPortalPlayground.cardVpnTag',
		defaultMessage: 'Common troubleshooting',
	},
	cardVpnTitle: {
		id: 'JsmPortalPlayground.cardVpnTitle',
		defaultMessage: 'VPN connection issues',
	},
	cardVpnDesc: {
		id: 'JsmPortalPlayground.cardVpnDesc',
		defaultMessage:
			'Having trouble connecting remotely? Learn the most common causes of VPN issues, how to troubleshoot them, and when to raise a request.',
	},
	cardPasswordTag: {
		id: 'JsmPortalPlayground.cardPasswordTag',
		defaultMessage: 'Common troubleshooting',
	},
	cardPasswordTitle: {
		id: 'JsmPortalPlayground.cardPasswordTitle',
		defaultMessage: 'Password reset guide',
	},
	cardPasswordDesc: {
		id: 'JsmPortalPlayground.cardPasswordDesc',
		defaultMessage:
			'Locked out of your account? Follow these steps to securely reset your password and regain access to your tools.',
	},
	closeButton: {
		id: 'JsmPortalPlayground.closeButton',
		defaultMessage: 'Close',
	},
	sendButton: {
		id: 'JsmPortalPlayground.sendButton',
		defaultMessage: 'Send',
	},
	articleBack: {
		id: 'JsmPortalPlayground.articleBack',
		defaultMessage: 'Back',
	},
	articleBackLabel: {
		id: 'JsmPortalPlayground.articleBackLabel',
		defaultMessage: 'Back to the help center',
	},
	draftWithRovo: {
		id: 'JsmPortalPlayground.draftWithRovo',
		defaultMessage: 'Draft with Rovo',
	},
	stillNeedHelpTitle: {
		id: 'JsmPortalPlayground.stillNeedHelpTitle',
		defaultMessage: 'Still need help?',
	},
	stillNeedHelpBody: {
		id: 'JsmPortalPlayground.stillNeedHelpBody',
		defaultMessage: 'Our AI helper can help you find what you need.',
	},
	askAnything: {
		id: 'JsmPortalPlayground.askAnything',
		defaultMessage: 'Ask anything',
	},
	submitRequest: {
		id: 'JsmPortalPlayground.submitRequest',
		defaultMessage: 'Submit a request',
	},
	articleLaptopTitle: {
		id: 'JsmPortalPlayground.articleLaptopTitle',
		defaultMessage: 'Set up your new laptop',
	},
	articleLaptopIntro: {
		id: 'JsmPortalPlayground.articleLaptopIntro',
		defaultMessage:
			'Follow the steps below to get your new laptop ready for work. Any questions, feel free to message the team.',
	},
	articleLaptopSection1: {
		id: 'JsmPortalPlayground.articleLaptopSection1',
		defaultMessage: 'Login with your credentials',
	},
	articleLaptopSection2: {
		id: 'JsmPortalPlayground.articleLaptopSection2',
		defaultMessage: 'Install Slack',
	},
	articleVpnTitle: {
		id: 'JsmPortalPlayground.articleVpnTitle',
		defaultMessage: 'Connecting to the VPN with your mobile device',
	},
	articleVpnIntro: {
		id: 'JsmPortalPlayground.articleVpnIntro',
		defaultMessage:
			'Follow the steps below to connect your phone to the VPN. Any questions, feel free to message the team.',
	},
	articleVpnSection1: {
		id: 'JsmPortalPlayground.articleVpnSection1',
		defaultMessage: 'Download your VPN app',
	},
	articleVpnSection2: {
		id: 'JsmPortalPlayground.articleVpnSection2',
		defaultMessage: 'Login with your credentials',
	},
	articlePasswordTitle: {
		id: 'JsmPortalPlayground.articlePasswordTitle',
		defaultMessage: 'Password reset guide',
	},
	articlePasswordIntro: {
		id: 'JsmPortalPlayground.articlePasswordIntro',
		defaultMessage:
			'Follow the steps below to reset your password. Any questions, feel free to message the team.',
	},
	articlePasswordSection1: {
		id: 'JsmPortalPlayground.articlePasswordSection1',
		defaultMessage: 'Verify your identity',
	},
	articlePasswordSection2: {
		id: 'JsmPortalPlayground.articlePasswordSection2',
		defaultMessage: 'Set your new password',
	},
});
